<script>
import ProjectsQuotes from "@/components/Projects/ProjectsQuotes.vue";

export default {
    name: "ProjectsQuotesModal",
    components: {
        ProjectsQuotes,
    },
    props: {
        idProject: {

        },
    },
    data() {
        return {
            isShow: false,
            result: false,
        };
    },
    watch: {
        isShow(v) {
            if (!v) {
                this.resolve(this.result);
                this.result = false;
            }
        },
    },
    methods: {
        show() {
            this.isShow = true;
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        close() {
            this.isShow = false;
        },
        quotesFilterFn(quote) {
            return quote.id_bright_quotes;
        },
    },
}
</script>

<template>
    <v-dialog
        v-if="isShow"
        v-model="isShow"
        max-width="90vw"
        scrollable
    >
        <v-card>
            <v-card-text class="pa-0">
                <projects-quotes
                    v-on="$listeners"
                    :id-project="idProject"
                    :footer-props="{itemsPerPageOptions:[10]}"
                    :quotes-filter="quotesFilterFn"
                    is-modal
                ></projects-quotes>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="close">Закрыть</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped lang="scss">

</style>
